<template>
    <div style="display: flex; flex-direction: column;">
        <SoccerHowClassHeader title="환급 계좌 등록"></SoccerHowClassHeader>
        <div style="flex: 1; padding: 20px;">
            <div style="box-shadow: 0px 0px 10px 0px #1010141A; margin-top: 16px; padding: 20px; border-radius: 12px;">
                <div style="margin-bottom: 10px;">보유 머니</div>
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="font-weight: 900; font-size: 24px; color: var(--color-main);">{{ cur_soccer_money | comma }}원</div>
                </div>
            </div>
            <div style="margin-top: 30px;">
                <div style="font-size: 14px; color: #606060;">등록된 계좌</div>
                <div v-if="myAccount.length > 0">
                    <div style="border-bottom: 1px solid #d9d9d9; display: flex; justify-content: space-between;" v-for="each, i in myAccount" :key="i">
                        <CreditCard :card_number="each.account_number" :bank_name="each.bank_name" :expiry_date="each.insert_date.substr(2, 2) + '/' + each.insert_date.substr(5, 2)" :needBoxShadow="false"></CreditCard>
                        <div @click="settingAccount(each.idx)" style="font-size: 14px; font-weight: 400; color: #606060; margin-top: 20px; text-decoration: underline;">설정</div>
                    </div>
                    <div @click="addAccount" style="width: 136px; height: 33px; border-radius: 22px; border: 1px solid var(--color-main); line-height: 33px; text-align: center; font-weight: 500; margin: 0 auto; margin-top: 25px;">+ 계좌 추가</div>
                </div>
                <div v-else style="border: 1px dashed #d9d9d9;  border-radius: 6px; padding: 20px; text-align: center; margin-top: 10px;">
                    <div style="font-size: 12px; font-weight: 500;">계좌 정보가 없습니다</div>
                    <div @click="addAccount(); $Util.sendEventClick('마이_머니_환급계좌등록')" style="font-size: 12px; width: 136px; height: 33px; border-radius: 22px; border: 1px solid var(--color-main); line-height: 33px; text-align: center; font-weight: 500; margin: 0 auto; margin-top: 15px;">
                        + 환급 계좌 등록
                    </div>
                </div>
            </div>
            <CommonPopupFrame :closeCompleteAction="closeSettingAccount" :changeHeight="30" :changeBottom="0" :isOpen="showSettingAccount">
                <div style="display: flex; flex-direction: column;">
                    <div style="padding: 20px;">
                        <div style="width: 70px; height: 3px; margin: 0 auto; margin-top: 10px;">
                            <div style="text-align: center; font-size: 20px; font-weight: 500;">설정</div>
                        </div>
                        <div style="display: flex;  justify-content: center; align-items: center; box-shadow: 0px 1px 5px 0px #00000040; border-radius: 50%; width: 35px; height: 35px; margin-top: -10px; float: right;" @click="() => { showSettingAccount = false }">
                            <img style="width: 13px;" :src="require('@/assets/img/black_x_btn_new.png')" alt="">
                        </div>
                    </div>
                    <div @click="confirmDeleteAccount" style="padding: 20px; text-align: center; font-weight: 500;">삭제</div>
                </div>
            </CommonPopupFrame>
            <CommonPopupFrame :closeCompleteAction="closeModal" :changeHeight="90" :changeBottom="0" :isOpen="showModal">
                <div style="display: flex; flex-direction: column; height: 100%;">
                    <div style="padding: 20px;">
                        <div style="width: 70px; height: 3px; border-radius: 10px; background-color: #d9d9d9; margin: 0 auto;"></div>
                        <div style="display: flex; justify-content: center; align-items: center; box-shadow: 0px 1px 5px 0px #00000040; border-radius: 50%; width: 35px; height: 35px; float: right;" @click="() => { showModal = false }">
                            <img style="width: 13px;" :src="require('@/assets/img/black_x_btn_new.png')" alt="">
                        </div>
                    </div>
                    <div style="flex: 1; height: 100%; font-weight: 500; overflow-y: scroll; overflow-x: hidden;" @touchmove.stop="() => { }">
                        <div style="padding: 20px; padding-top: 0;">
                            <div style="font-size: 20px; margin-bottom: 4px;">환급 받을 계좌를 등록해주세요</div>
                            <div style="font-size: 14px;color: #606060; line-height: 17px;">환급금이 등록된 계좌로 입금됩니다<br>정확한 정보를 입력해주세요</div>
                        </div>
                        <div style="height: 10px; width: calc(100% + 40px); background-color: #f5f5f5; margin: 0 20px; margin-left: -20px;"></div>
                        <div style="padding: 20px;">
                            <div style="border-bottom: 1px solid #f3f3f3; padding-bottom: 20px;">
                                <div>계좌번호 입력</div>
                                <input v-model="accountNumber" placeholder="계좌를 입력해주세요" style="padding: 14px; outline: none; border: 1px solid #d9d9d9; border-radius: 9px; width: 100%; margin-top: 10px;" type="text">
                            </div>
                            <div style="margin-top: 20px;">
                                <div>은행</div>
                                <div style="position: relative; padding: 14px; border: 1px solid #d9d9d9; border-radius: 9px; margin-top: 10px; height: 54px; display: flex; align-items: center;">
                                    <div style="font-weight: 400; color: #808080;">{{ selectedBank ? selectedBank : '은행을 선택해주세요' }}</div>
                                    <div @click="showAccountList" style="position: absolute; display: flex; justify-content: center; align-items: center; height: 30px; right: 0px; bottom: 10px; width: 100%;">
                                        <img style="width: 20px; transition: all 0.3s; position: absolute; right: 20px;" :style="{ transform: isShowBankList ? 'rotateX(180deg)' : '' }" :src="require('@/assets/img/down_arrow_new.png')" alt="">
                                    </div>
                                    <div @touchmove.stop="() => { }" v-if="isShowBankList" style="position: absolute; top: 70px; overflow-y: scroll; height: 250px; border: 1px solid #d9d9d9; left: 0; width: 100%; border-radius: 9px; padding: 20px; margin-bottom: 20px;">
                                        <div @click="selectBank(each)" v-for="each, i in bacnkList" :key="i" style="font-weight: 400; color: #545454; padding: 10px 0;">{{ each }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 100px;">
                        <div @click="saveAccount" style="width: 274px; height: 47px; line-height: 47px; border: 1px solid var(--color-main); border-radius: 22px; text-align: center; font-size: 20px; font-weight: 500; margin: 0 auto; margin-top: 15px;">저장하기</div>
                    </div>
                </div>
            </CommonPopupFrame>
        </div>

    </div>
</template>

<script>
import { SoccerHowClassHeader, CreditCard } from '@/components/common';
import { CommonPopupFrame } from '@/components/modal/my';
import ResponseCode from '../../../ResponseCode';

export default {
    name: 'AccountRegist',
    components: { SoccerHowClassHeader, CreditCard, CommonPopupFrame },
    data() {
        return {
            page: 1,
            myAccount: [],
            showModal: false,
            accountNumber: '',
            isShowBankList: false,
            bacnkList: ['NH농협', '카카오뱅크', 'KB국민', '신한', '토스뱅크', '우리', 'IBK기업', '하나', '새마을', '부산', '대구', '케이뱅크', '신협', '우체국', 'SC제일', '경남', '광주', '수협', '전북', '저축은행', '제주', '씨티', 'KDB산업', 'SBI저축은행'],
            selectedBank: '',
            showSettingAccount: false,
            accountIdx: -1,
        }
    },
    created() {
        this.getMyAccount()
    },
    computed: {
        cur_soccer_money() {
            const money = this.$GlobalStore.loginInfo().soccer_money
            return money ? money : 0;
        }
    },
    methods: {
        async getMyAccount() {
            const parameters = {}
            parameters.page = this.page

            const res = await this.$Axios.get('/api/bank/account/list', { params: parameters })

            this.myAccount = res.data.accounts
        },
        selectBank(bank) {
            this.selectedBank = bank
            this.isShowBankList = false
        },
        closeModal() {
            this.showModal = false
        },
        addAccount() {

            this.showModal = true
        },
        showAccountList() {
            this.isShowBankList = !this.isShowBankList
        },
        async saveAccount() {
            const parameters = {}
            parameters.mode = 'insert'
            parameters.account_number = this.accountNumber
            parameters.bank_name = this.selectedBank
            parameters.account_owner_name = this.$GlobalStore.loginInfo().name

            const res = await this.$Axios.post('/api/bank/account/save', parameters)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getMyAccount()
                this.showModal = false
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        settingAccount(idx) {
            this.showSettingAccount = true
            this.accountIdx = idx
        },
        closeSettingAccount() {
            this.showSettingAccount = false
        },
        async deleteAccount() {
            const parameters = {}
            parameters.idx = this.accountIdx

            const res = await this.$Axios.post('/api/bank/account/delete', parameters)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getMyAccount()
                this.showSettingAccount = false
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        confirmDeleteAccount() {
            this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">결제 수단 삭제</strong><br>선택하신 결제수단을 삭제할까요?', () => {
                this.deleteAccount()
            }, '삭제하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}
</style>